import request from '@/util/request'

// 赛事项目列表-个人项目
export const listPersonProject = (data) => {
  return request({
    url: `/api/register/competition/project/listPersonProject`,
    method: 'GET',
    data
  })
}

// 赛事项目列表-集体项目
export const listTeamProject = (data) => {
  return request({
    url: `/api/register/competition/project/listTeamProject`,
    method: 'GET',
    data
  })
}

// 赛事项目列表-对练项目
export const listTrainProject = (data) => {
  return request({
    url: `/api/register/competition/project/listTrainProject`,
    method: 'GET',
    data
  })
}
